import { render, staticRenderFns } from "./pointsExchangeAddAndEdit.vue?vue&type=template&id=04ca356c&scoped=true"
import script from "./pointsExchangeAddAndEdit.vue?vue&type=script&lang=js"
export * from "./pointsExchangeAddAndEdit.vue?vue&type=script&lang=js"
import style0 from "./pointsExchangeAddAndEdit.vue?vue&type=style&index=0&id=04ca356c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ca356c",
  null
  
)

export default component.exports